import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';

import LoginForm from '../login/loginForm';
import Input from '../../components/common/input';

import {sendForgotPassword} from '../../actions/session';

const ForgotPasswordForm = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state) => state.session.forgotPasswordErrors);
  const shouldLockForm = useSelector((state) => state.session.isLoading);

  const [email, setEmail] = useState('');

  return (
    <LoginForm
      title="Reset Password"
      subtitle="Please enter your email address to reset your password."
      submitLabel="Submit"
      submitAction={() => dispatch(sendForgotPassword(email))}
      disabled={shouldLockForm}
    >
      <Input
        name='email'
        id='email'
        label='Email'
        type='email'
        value={email}
        changeAction={setEmail}
        placeholder='Enter Email'
        autoComplete='username'
        disabled={shouldLockForm}
        errors={errors?.email}
        focusOnError={errors?.email}
      />
    </LoginForm>
  );
};

export default ForgotPasswordForm;
